import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import { HStack, Pressable, Stack, Text, VStack } from "native-base";
import PhoneInput from "react-phone-number-input";
import es from "react-phone-number-input/locale/es.json";
import API from "../../api";
import { StateContext, StatusContext } from "../../contexts";
import Modal from "../modal";
import colors from "../../constants/colors";
import styles from "./styles.module.css";

function ContactModal(props) {
  const { isOpen, onClose, id } = props;
  const state = useContext(StateContext);
  const status = useContext(StatusContext);
  const [name, setName] = useState(
    `${state.user.firstName} ${state.user.lastName}`,
  );
  const [email, setEmail] = useState(state.user.email);
  const [phone, setPhone] = useState(state.user.phone);
  const [isLoading, setIsLoading] = useState(false);

  const onSendContact = async () => {
    try {
      setIsLoading(true);
      await API().post("/contact-forms/send", {
        data: { name, email, phone, quotation: id },
      });
      status.updateSuccessMessage(
        "¡Tú solicitud se ha enviado con éxito! Uno de nuestros ejecutivos se pondrá en contacto contigo.",
      );
      onClose();
    } catch (error) {
      status.updateErrorMessage(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal maxWidth={600} isOpen={isOpen} onRequestClose={onClose}>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          onSendContact();
        }}>
        <VStack padding={5} space={5}>
          <Text>Agente asignado:</Text>
          <VStack>
            <Text>Montserrat Martínez Uriarte</Text>
            <Text>soporteautotur@mobilityado.com</Text>
          </VStack>
          <Text>
            Será un placer poder acompañarte en tu experiencia de viaje si
            deseas continuar con tu compra da clic en CONTINUAR.
          </Text>
          {!state.isLoggedIn && (
            <label className={styles.input}>
              <Text color={colors.secondary}>Nombre</Text>
              <input
                value={name}
                onChange={(event) => setName(event.target.value)}
                required
                disabled={isLoading}
              />
            </label>
          )}
          {!state.isLoggedIn && (
            <label className={styles.input}>
              <Text color={colors.secondary}>Correo electrónico</Text>
              <input
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                type="email"
                required
                disabled={isLoading}
              />
            </label>
          )}
          {!state.isLoggedIn && (
            <label className={styles.input}>
              <Text>Número de teléfono</Text>
              <PhoneInput
                labels={es}
                defaultCountry="MX"
                disabled={isLoading}
                value={phone}
                onChange={setPhone}
                required
              />
            </label>
          )}
          <HStack space={5}>
            <Pressable
              disabled={isLoading}
              flex={1}
              backgroundColor={colors.primary}
              paddingY={2}
              borderRadius="full"
              onPress={onClose}>
              <Text color={colors.white} textAlign="center">
                CONTINUAR
              </Text>
            </Pressable>
            <button className="flex-1" disabled={isLoading}>
              <Stack
                backgroundColor={colors.primary}
                paddingY={2}
                borderRadius="full">
                <Text color={colors.white} textAlign="center">
                  ENVIAR
                </Text>
              </Stack>
            </button>
          </HStack>
        </VStack>
      </form>
    </Modal>
  );
}

ContactModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default React.memo(ContactModal);
